/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { CMSLink } from "frontend/src/components/CMSLink"
import { Icon } from "frontend/src/components/Icon"
import { Flex, SectionGrid } from "frontend/src/components/Layout"

function PreHeader({ items }) {
  return (
    <SectionGrid sx={{ bg: "almostBlack", overflow: "hidden" }}>
      <SectionGrid.wide>
        <Flex.row
          wrap
          justify={["space-around", "space-between"]}
          sx={{ flex: 1, px: 6, height: "40px" }}
        >
          {items.map(({ icon, text, link }) => (
            <CMSLink
              key={text + "kj"}
              sx={{
                textDecoration: "none",
                color: "white",
                fontSize: ["0", "0", "1"],
                fontFamily: "heading",
                fontWeight: "regular",
                display: "flex",
                alignItems: "center",
                height: "100%",
              }}
              link={link}
            >
              <Icon name={icon} size={22} color="white" />
              <div sx={{ ml: 3, fontSize: "14px", fontWeight: "light", letterSpacing: "0.5px" }}>
                {text}
              </div>
            </CMSLink>
          ))}
        </Flex.row>
      </SectionGrid.wide>
    </SectionGrid>
  )
}
export { PreHeader }
